import React, { useEffect, useState, useCallback } from 'react';
import { IntlProvider, MessageFormatElement } from 'react-intl';
import { langObserver } from './eventObserver';
import { ILangContext, LangContext } from './LangContext';

interface ILangProvider {
  children: React.ReactNode
  enMessages: Record<string, string> | Record<string, MessageFormatElement[]>
  locales: ILangContext
}

const useLocale = localStorage.getItem('dubLocale') || 'en';

export const LangProvider: React.FC<ILangProvider> = ({
  children, locales, enMessages,
}) => {
  const [locale, setLocale] = useState(useLocale);
  const [messages, setMessages] = useState(enMessages);

  const changeLocale = useCallback((newLocale) => {
    locales[newLocale]?.().then((localeMessages) => {
      setMessages(localeMessages);
      setLocale(newLocale);
    });
  }, [locales, setLocale, setMessages]);

  useEffect(() => {
    changeLocale(useLocale);
    langObserver.off({ eventType: 'SET_LOCALE' });
    langObserver.on({ eventType: 'SET_LOCALE', callback: changeLocale });
    return () => {
      langObserver.off();
    };
  }, [changeLocale]);

  return (
    <IntlProvider locale={locale} messages={messages} defaultLocale="en">
      <LangContext.Provider value={locales}>
        {children}
      </LangContext.Provider>
    </IntlProvider>
  );
};
